<template>
  <el-dialog :title="$t('couponManage.addCoupon')" :visible.sync="dialogVisible" width="70%"
    @close="handleClose">
    <el-form ref="form" :model="addCouponInfo" label-width="120px">
      <el-form-item :label="$t('couponManage.couponCode')" :rules="[{ required: true, message: $t('couponManage.couponCodeRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.couponCode"
          :placeholder="$t('couponManage.couponCodeRequired')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.couponName')" :rules="[{ required: true, message: $t('couponManage.couponNameRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.couponName"
          :placeholder="$t('couponManage.couponNameRequired')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.couponType')" :rules="[{ required: true, message: $t('couponManage.couponTypeRequired'), trigger: 'change' }]">
        <el-select v-model="addCouponInfo.couponType" :placeholder="$t('couponManage.couponTypeRequired')"
          style="width:100%" @change="_changeCouponType">
          <el-option disabled :value="''" :label="$t('couponManage.couponTypeRequired')" />
          <el-option :label="$t('couponManage.fullReduction')" value="01" />
          <el-option :label="$t('couponManage.discount')" value="02" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="addCouponInfo.couponType === '01'" :label="$t('couponManage.discountAmount')"
        :rules="[{ required: true, message: $t('couponManage.discountAmountRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.discountAmount" type="number"
          :placeholder="$t('couponManage.discountAmountRequired')" />
      </el-form-item>

      <el-form-item v-if="addCouponInfo.couponType === '02'" :label="$t('couponManage.discountPercent')"
        :rules="[{ required: true, message: $t('couponManage.discountPercentRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.discountPercent" type="number"
          :placeholder="$t('couponManage.discountPercentRequired')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.minAmount')">
        <el-input v-model="addCouponInfo.minAmount" type="number"
          :placeholder="$t('couponManage.minAmountPlaceholder')" />
      </el-form-item>

      <el-form-item v-if="addCouponInfo.couponType === '02'" :label="$t('couponManage.maxDiscount')">
        <el-input v-model="addCouponInfo.maxDiscount" type="number"
          :placeholder="$t('couponManage.maxDiscountPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.description')">
        <el-input v-model="addCouponInfo.description" type="textarea"
          :placeholder="$t('couponManage.descriptionPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.totalQuantity')"
        :rules="[{ required: true, message: $t('couponManage.totalQuantityRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.totalQuantity" type="number"
          :placeholder="$t('couponManage.totalQuantityRequired')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.limitPerUser')">
        <el-input v-model="addCouponInfo.limitPerUser" type="number"
          :placeholder="$t('couponManage.limitPerUserPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.issueType')"
        :rules="[{ required: true, message: $t('couponManage.issueTypeRequired'), trigger: 'change' }]">
        <el-select v-model="addCouponInfo.issueType" :placeholder="$t('couponManage.issueTypeRequired')"
          style="width:100%">
          <el-option disabled :value="''" :label="$t('couponManage.issueTypeRequired')" />
          <el-option :label="$t('couponManage.userReceive')" value="01" />
          <el-option :label="$t('couponManage.shopGive')" value="02" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('couponManage.validDays')">
        <el-input v-model="addCouponInfo.validDays" type="number"
          :placeholder="$t('couponManage.validDaysPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.startTime')">
        <el-date-picker v-model="addCouponInfo.startTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('couponManage.startTimePlaceholder')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.endTime')">
        <el-date-picker v-model="addCouponInfo.endTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('couponManage.endTimePlaceholder')" style="width:100%" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveCouponInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveShopCoupon } from '@/api/coupon/couponApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddShopCoupon',
  data() {
    return {
      dialogVisible: false,
      addCouponInfo: {
        couponCode: '',
        couponName: '',
        couponType: '',
        description: '',
        discountAmount: '',
        discountPercent: '',
        minAmount: '0',
        maxDiscount: '',
        totalQuantity: '',
        limitPerUser: '1',
        issueType: '',
        validDays: '',
        startTime: '',
        endTime: '',
        shopId: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      // 获取店铺ID
      this.addCouponInfo.shopId = getShopId()
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.addCouponInfo = {
        couponCode: '',
        couponName: '',
        couponType: '',
        description: '',
        discountAmount: '',
        discountPercent: '',
        minAmount: '0',
        maxDiscount: '',
        totalQuantity: '',
        limitPerUser: '1',
        issueType: '',
        validDays: '',
        startTime: '',
        endTime: '',
        shopId: ''
      }
    },
    _changeCouponType() {
      // 切换优惠类型时清空相关字段
      if (this.addCouponInfo.couponType === '01') {
        this.addCouponInfo.discountPercent = ''
        this.addCouponInfo.maxDiscount = ''
      } else {
        this.addCouponInfo.discountAmount = ''
      }
    },
    async saveCouponInfo() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            await saveShopCoupon(this.addCouponInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          }
        })
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>

